// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__3Zjub","noInteraction":"EventWrapper_noInteraction__2EC3x"};